import { HealthPage, LastWorkspaceResolver, LazyPage } from './-components';
import { createFileRoute } from '@tanstack/react-router';

function HealthRoute() {
  return (
    <LastWorkspaceResolver>
      <LazyPage>
        <HealthPage />
      </LazyPage>
    </LastWorkspaceResolver>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/health')({
  component: HealthRoute,
});
